/**
 * GÜN RENKLERİ — UNİKOÇ program tablosu (sürüm 9a, karar 07.10.2026)
 *
 * Eski panelde ders/gün renkleri ekrandan ekrana değişiyordu ve bir ekranda
 * hafta Cumartesi'den başlıyordu. Karar (ONERI §5.2): hafta PAZARTESİ başlar,
 * renkler UNİKOÇ'tan ve TEK tablodan. Bu dosya o tablo.
 *
 * Sıra Pazartesi = 0 … Pazar = 6. JavaScript `getDay()` Pazar = 0 verir;
 * dönüşüm yalnız `gunSirasi` içinde, ki her ekran kendi `(g + 6) % 7`sini
 * yazıp birinde ters çevirmesin.
 */
export interface HaftaGunu {
  /** Pazartesi = 0 … Pazar = 6 */
  sira: number;
  ad: string;
  kisa: string;
  /** Satır/kart zemini — tam sınıf adı (Tailwind birleştirilmiş adı tarayamaz). */
  zemin: string;
}

export const HAFTA_GUNLERI: readonly HaftaGunu[] = [
  { sira: 0, ad: "Pazartesi", kisa: "Pzt", zemin: "bg-gun-pzt" },
  { sira: 1, ad: "Salı", kisa: "Sal", zemin: "bg-gun-sal" },
  { sira: 2, ad: "Çarşamba", kisa: "Çar", zemin: "bg-gun-car" },
  { sira: 3, ad: "Perşembe", kisa: "Per", zemin: "bg-gun-per" },
  { sira: 4, ad: "Cuma", kisa: "Cum", zemin: "bg-gun-cum" },
  { sira: 5, ad: "Cumartesi", kisa: "Cmt", zemin: "bg-gun-cmt" },
  { sira: 6, ad: "Pazar", kisa: "Paz", zemin: "bg-gun-paz" },
];

/**
 * Tarihin haftadaki sırası, Pazartesi = 0. YEREL gün okunuyor (`getDay`):
 * çağıran Europe/Istanbul takvim gününü temsil eden bir `Date` vermeli —
 * UTC gece yarısı bir değer, İstanbul'da bir önceki günün akşamına düşebilir.
 */
export function gunSirasi(tarih: Date): number {
  return (tarih.getDay() + 6) % 7;
}

/** Tarihin gün kaydı (ad, kısa ad, zemin sınıfı). */
export function haftaGunu(tarih: Date): HaftaGunu {
  return HAFTA_GUNLERI[gunSirasi(tarih)]!;
}
